// 与pc关联的页面
const Bill = () => import('@/views/pc/Bill')

export default [
  {
    path: '/pc/bill',
    component: Bill,
    meta: {
      title: '对账收款单'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/pc.js